export default __webpack_public_path__ + "static/media/color01.8404db54.png";